module.exports = __webpack_public_path__ + "img/landing.bc63cef0.png";